import { configureStore } from '@reduxjs/toolkit';
import supportTicketReducer from './slices/supportTicketState';
import userReducer from './slices/userState';
import countReducer from './slices/countState';
import chatReducer from './slices/chatState';


export const store = configureStore({
  reducer: {
    supportTicketState: supportTicketReducer,
    userState: userReducer,
    countState: countReducer,
    chatState: chatReducer,
  },
});

export default store; 